import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-welcome-bar',
  templateUrl: './welcome-bar.component.html',
  styleUrls: ['./welcome-bar.component.scss']
})
export class WelcomeBarComponent implements OnInit {

  constructor( public dataService: DataService, private router: Router) { }
  user_code: string;
  user_code_type: string = 'action'; // 'action or 'zip'

  user_code_po: string;
  user_code_ph: string;

  list_texts: [string] = ['De verschillende mogelijkheden bij bleken',
    'Advies voor, tijdens en na behandeling',
    'Succesvolle inzet in uw praktijk van Zoom!'
  ];

  new_user: any  = {};

  @Input() page: string = 'default';
  @Input() buttons: boolean = false;

  ngOnInit() {
  }

  // this function is used to automatically put the - symbol inside the input in the  desired places. Could be moved to a filter.
  onKeyUp(event){
    if((event.target.value.length === 4) ){
      this.user_code = event.target.value+'-';
    }
    else {
      this.user_code = event.target.value;
    }
  }

  fixCodeFormat(){
    if(!this.user_code) return

    let user_code = this.user_code;
    let format_str: string = '9999-999999';
    // correct postion of '-' if needed
    for( let i=0; i < user_code.length; i++){
      let target_char = format_str[i];
      let char = user_code[i];
      if( target_char == '-' && char != '-' ){
        user_code = user_code.slice(0,i) + '-' + user_code.slice(i,9999);
      }
    }
    this.user_code = user_code;
  }

  user_code_is_valid(){
    if(!!this.user_code) return this.user_code.length == 11 && this.user_code[4] == "-";
    else return !!this.user_code_po &&  this.user_code_po.length > 3 && !!this.user_code_ph && this.user_code_ph.length == 6;
  }

  check_user_code(mode?: string){
    this.user_code_type = mode ||'action';
     if(!!this.user_code) {
       return this.check_code( this.user_code );
     }
     let code = this.user_code_po.slice(0,4) + '-' + this.user_code_ph;
     return this.check_code(code);
  }

  // this function takes the user code and sets user status. Returns a result or error from the server
  check_code(code){
    // this.user_status = 'LOOKUP_STARTED';

    this.dataService.getUserForCode(code).subscribe(
      (client) => {
        console.log(client);
        if(!!client.error){
          // this.user_status = 'LOOKUP_FAILED';
          if(this.user_code_type == 'zip') {
            this.dataService.presentMessage('Deze combinatie is niet bij ons bekend.', 'error');
          } else {
            this.dataService.presentMessage('Oeps. Het lijkt erop dat deze actiecode niet bestaat.', 'error');
          }
        }
        else {
          // this.user_info = client;
          this.dataService.user_info = client;
          this.dataService.saveUserInfo(this.dataService.subuser_info);
          // this.dataService.user_id = this.user_info.id;
          // this.user_status = 'LOOKUP_COMPLETED';
          if(!!client.language && !this.new_user.language){
            this.new_user.language = client.language;
            this.dataService.set_language(client.language.toLowerCase())
          }
        }
    },
    (err) => {
      // this.user_status = 'LOOKUP_FAILED';
      this.dataService.presentMessage('Oeps. Het lijkt er op dat er iets mis is gegaan bij het controleren van de code. Weet je zeker dat de code juist is?','error');
    },
    () => {
      console.debug('done getting code information');
      this.goToShop();
    }
    )
  }

  goToShop() {
    this.router.navigate(['account/create']);
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/welcome-bar/welcome-bar.component.ts